"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LensCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const BaseInThisSnapCard_1 = require("../BaseInThisSnapCard");
/**
 * Component to information about the Lens in a Snap.
 */
function LensCard({ metadata, onClick }) {
    return ((0, jsx_runtime_1.jsx)(BaseInThisSnapCard_1.BaseInThisSnapCard, { title: metadata.lensName, subtitle: metadata.creatorName, iconUrl: metadata.iconUrl, clickableUrl: metadata.unlockUrl, onClick: onClick }));
}
exports.LensCard = LensCard;
//# sourceMappingURL=LensCard.js.map